import AddressCrud from '../Address.class'
import axios from 'axios'
import get from 'lodash/get'

const baseURL = '/api/place/'

export default class EventPlace {
	constructor (init = {}) {
		this.id = null
		this.setDefaultData()
		if (typeof init === 'number') {
			this.id = init
			this.getSingle().then()
		} else {
			this.setDefaultData(init)
		}
	}

	setDefaultData (init = {}) {
		if (!init) return

		this.id = get(init, 'id') && !isNaN(Number(init.id)) ? Number(init.id) : 0
		this.name = get(init, 'name') && init.name ? init.name.toString() : ''
		this.tk = get(init, 'tk', false)
		this.visible = get(init, 'visible') ? Boolean(init.visible) : false
		this.description = get(init, 'description') && init.description ? init.description.toString() : ''
		this.email = get(init, 'email') && init.email ? init.email.toString() : ''
		this.fb_link = get(init, 'fb_link') && init.fb_link ? init.fb_link.toString() : ''
		this.vk_link = get(init, 'vk_link') && init.vk_link ? init.vk_link.toString() : ''
		this.tk = get(init, 'tk') ? Boolean(init.tk) : false
		this.visible = get(init, 'visible') ? Boolean(init.visible) : false
		this.address = get(init, 'address') && init.address ? new AddressCrud(init.address) : new AddressCrud()
		this.errors = {}
	}

	static url = baseURL

	async getSingle () {
		try {
			const {data} = await axios.get(`${baseURL}${this.id}`)
			this.setDefaultData(data.data)
		} catch (e) {
			console.error(e)
		}
	}

	static getAll (params) {
		return axios.get(baseURL, {params})
			.then(res => {
				return {
					...res.data,
					data: res.data.data.map(item => new EventPlace(item))
				}
			})
			.catch(err => {
				console.error(err)
				return null
			})
	}

	get formData () {
		const formData = new URLSearchParams()

		formData.append('name', this.name)
		formData.append('description', this.description)
		formData.append('email', this.email)
		formData.append('fb_link', this.fb_link)
		formData.append('vk_link', this.vk_link)
		formData.append('tk', Number(this.tk)) // return '1' || '0'
		formData.append('visible', Number(this.visible)) // return '1' || '0'

		// if (this.address.id) {
		// 	formData.append('address_id', this.address.id)
		// }
		formData.append('address[city_id]', this.address.city.id)
		formData.append('address[region_id]', this.address.region.id)
		formData.append('address[country_id]', this.address.country.id)
		formData.append('address[post_code]', this.address.post_code)
		if (this.address.street) {
			formData.append('address[street]', this.address.street)
		}
		if (this.address.house) {
			formData.append('address[house]', this.address.house)
		}
		if (this.address.building) {
			formData.append('address[building]', this.address.building)
		}
		if (this.address.wing) {
			formData.append('address[wing]', this.address.wing)
		}
		if (this.address.apartament) {
			formData.append('address[apartment]', this.address.apartament)
		}
		if (this.address.place) {
			formData.append('address[place]', this.address.place)
		}
		if (this.address.geo_point) {
			formData.append('address[geo_point]', this.address.geo_point)
		}

		return formData
	}

	create () {
		return axios.post(`${baseURL}`, this.formData)
			.then(res => {
				return res
			})
			.catch(err => {
				console.error(err)
				return err.response
			})
	}

	update () {
		return axios.put(`${baseURL}${this.id}`, this.formData)
			.then(res => {
				return res
			})
			.catch(err => {
				console.error(err)
				return err.response
			})
	}

	delete () {
		return axios.delete(`${baseURL}${this.id}`)
	}

	createErrors (obj) {
		let newObj = {}
		for (let key in obj) {
			const newErrorStr = obj[key].reduce((accumulator, item) => {
				return accumulator + item
			}, '')
			const newKey = key.replaceAll('.', '~')
			newObj[newKey] = newErrorStr
		}
		this.errors = newObj
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/Event/EventPlace.class.js